import React, { useState } from 'react';
import { Shop, AppSettings, HistoryEntry } from '../App';
import { ChevronDownIcon, ChevronUpIcon } from 'lucide-react';
interface HistoryProps {
  history: HistoryEntry[];
  settings: AppSettings;
}
export const History: React.FC<HistoryProps> = ({
  history,
  settings
}) => {
  const [expandedEntryId, setExpandedEntryId] = useState<string | null>(null);
  const toggleExpand = (entryId: string) => {
    if (expandedEntryId === entryId) {
      setExpandedEntryId(null);
    } else {
      setExpandedEntryId(entryId);
    }
  };
  const calculateUsage = (shop: Shop) => {
    return Math.max(0, shop.currentReading - shop.previousReading);
  };
  const calculateBill = (shop: Shop) => {
    const usage = calculateUsage(shop);
    return usage * settings.costPerUnit + shop.additionalCharges;
  };
  // Format the month and year for display
  const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
  const formatPeriod = (period: {
    month: number;
    year: number;
  }) => {
    return `${months[period.month]} ${period.year}`;
  };
  // Create a unique ID for each entry to use as the expanded state key
  const getEntryId = (entry: HistoryEntry) => {
    return `${entry.period.month}-${entry.period.year}`;
  };
  return <div className="space-y-4" data-id="element-26">
      <h2 className="text-xl font-semibold text-gray-800" data-id="element-27">Reading History</h2>
      {history.length === 0 ? <div className="bg-white p-6 rounded-lg border border-gray-200 text-center" data-id="element-28">
          <p className="text-gray-600" data-id="element-29">No history available yet</p>
          <p className="text-sm text-gray-500 mt-1" data-id="element-30">
            Save your first set of readings to see them here
          </p>
        </div> : <div className="space-y-3" data-id="element-31">
          {history.slice().reverse().map(entry => {
        const entryId = getEntryId(entry);
        return <div key={entryId} className="bg-white rounded-lg border border-gray-200 overflow-hidden" data-id="element-32">
                  <div className="flex justify-between items-center p-4 cursor-pointer hover:bg-gray-50" onClick={() => toggleExpand(entryId)} data-id="element-33">
                    <div data-id="element-34">
                      <h3 className="font-medium" data-id="element-35">
                        {formatPeriod(entry.period)}
                      </h3>
                      <p className="text-sm text-gray-600" data-id="element-36">
                        {entry.shops.length} shops
                      </p>
                    </div>
                    <div data-id="element-37">
                      {expandedEntryId === entryId ? <ChevronUpIcon size={20} data-id="element-38" /> : <ChevronDownIcon size={20} data-id="element-39" />}
                    </div>
                  </div>
                  {expandedEntryId === entryId && <div className="border-t border-gray-200 p-4" data-id="element-40">
                      <div className="overflow-x-auto" data-id="element-41">
                        <table className="w-full text-sm" data-id="element-42">
                          <thead data-id="element-43">
                            <tr className="bg-gray-50" data-id="element-44">
                              <th className="py-2 px-3 text-left" data-id="element-45">Shop</th>
                              <th className="py-2 px-3 text-right" data-id="element-46">Previous</th>
                              <th className="py-2 px-3 text-right" data-id="element-47">Current</th>
                              <th className="py-2 px-3 text-right" data-id="element-48">Usage</th>
                              <th className="py-2 px-3 text-right" data-id="element-49">Bill</th>
                            </tr>
                          </thead>
                          <tbody data-id="element-50">
                            {entry.shops.map(shop => <tr key={shop.id} className="border-t border-gray-100" data-id="element-51">
                                <td className="py-2 px-3" data-id="element-52">{shop.name}</td>
                                <td className="py-2 px-3 text-right" data-id="element-53">
                                  {shop.previousReading}
                                </td>
                                <td className="py-2 px-3 text-right" data-id="element-54">
                                  {shop.currentReading}
                                </td>
                                <td className="py-2 px-3 text-right" data-id="element-55">
                                  {calculateUsage(shop)}
                                </td>
                                <td className="py-2 px-3 text-right font-medium" data-id="element-56">
                                  ₹{calculateBill(shop).toFixed(2)}
                                </td>
                              </tr>)}
                          </tbody>
                        </table>
                      </div>
                    </div>}
                </div>;
      })}
        </div>}
    </div>;
};